<template>
  <div>
    <div class="tw-text-gray-500 tw-text-xs tw-font-normal">{{ title }}</div>
    <div class="tw-text-gray-800 tw-text-sm">
      <slot>{{ value }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    value: [String, Number],
  },
};
</script>
